 

const getters = {
  getPortfolioManagers: state => state.portfolioManagers
};

const mutations = {
  SET_PORTFOLIO(state, payload) {
    state.portfolioManagers = payload.portfolioManagers;
  }
};

const state = {
  portfolioManagers: []
};

export default {
  getters,
  mutations,
  state
};
